/**
 * This page will display the page to donate to an event.
 */

import DonateScreen, {
  getEventDonateStaticPaths,
  getEventDonateStaticProps,
} from "@dreambigger/inspire-events/src/components/views/donate";
import { GetStaticPaths, GetStaticProps } from "next";

// Get the static paths for the donate page that we want to prerender.
export const getStaticPaths: GetStaticPaths = getEventDonateStaticPaths;

// Get data to statically generate the donate page.
export const getStaticProps: GetStaticProps = getEventDonateStaticProps;

export default DonateScreen;
